import Link from "next/link";

type LogoSize = "sm" | "md" | "lg";

type LogoProps = {
	size?: LogoSize;
	href?: string;
	className?: string;
};

const sizes: Record<LogoSize, string> = {
	sm: "text-lg",
	md: "text-xl",
	lg: "text-2xl",
};

export function Logo({ size = "md", href, className = "" }: LogoProps) {
	const textSize = sizes[size];

	const content = (
		<span
			className={`font-display font-bold ${textSize} tracking-tight text-foreground ${className}`}
		>
			SendPigeon
		</span>
	);

	if (href) {
		return (
			<Link href={href} className="block">
				{content}
			</Link>
		);
	}

	return content;
}
